import { API_PREFIX } from '../consts';
import { GET } from '../utils/request';
import { FEATURE_MIXPANEL_LOGS_ENABLED } from 'src/consts/feature';

export function queryMixpanelLogToggle() {
  return GET(`${API_PREFIX}/v1/config/feature/${FEATURE_MIXPANEL_LOGS_ENABLED}`);
}
